import { messages as activitiesTypeManageMessages } from '../views/oa/activitiesTypeManageLang'
import { messages as activitiesManageMessages } from '../views/oa/activitiesManageLang'
import { messages as noticeManageMessages } from '../views/oa/noticeManageLang'
import { messages as addNoticeViewMessages } from '../views/oa/addNoticeViewLang'
import { messages as editNoticeViewMessages } from '../views/oa/editNoticeViewLang'
import { messages as noticeDetailMessages } from '../views/oa/noticeDetailLang'
import { messages as complaintTypeMessages } from '../views/oa/complaintTypeLang'
import { messages as addComplaintTypeMessages } from '../views/oa/addComplaintTypeLang'
import { messages as editComplaintTypeMessages } from '../views/oa/editComplaintTypeLang'
import { messages as addComplaintMessages } from '../views/oa/addComplaintLang'
import { messages as complaintMessages } from '../views/oa/complaintLang'
import { messages as notepadManageMessages } from '../views/oa/notepadManageLang'
import { messages as visitManageMessages } from '../views/oa/visitManageLang'
import { messages as questionTitleMessages } from '../views/oa/questionTitleLang'
import { messages as questionAnswerManageMessages } from '../views/oa/questionAnswerManageLang'
import { messages as printQuestionAnswerMessages } from '../views/oa/printQuestionAnswerLang'
import { messages as addQuestionAnswerMessages } from '../views/oa/addQuestionAnswerLang'
import { messages as editQuestionAnswerMessages } from '../views/oa/editQuestionAnswerLang'
import { messages as printQuestionAnswerDetailMessages } from '../views/oa/printQuestionAnswerDetailLang'
import { messages as ownerVotingMessages } from '../views/oa/ownerVotingLang'
import { messages as addOwnerVotingMessages } from '../views/oa/addOwnerVotingLang'
import { messages as editOwnerVotingMessages } from '../views/oa/editOwnerVotingLang'
import { messages as printOwnerVotingMessages } from '../views/oa/printOwnerVotingLang'
import { messages as oaWorkflowManageMessages } from '../views/oa/oaWorkflowManageLang'
import { messages as newOaWorkflowManageMessages } from '../views/oa/newOaWorkflowManageLang'
import { messages as newOaWorkflowDoingMessages } from '../views/oa/newOaWorkflowDoingLang'
import { messages as attendanceClassesManageMessages } from '../views/oa/attendanceClassesManageLang'
import { messages as attendanceClassesStaffManageMessages } from '../views/oa/attendanceClassesStaffManageLang'
import { messages as todayAttendanceManageMessages } from '../views/oa/todayAttendanceManageLang'
import { messages as addAttendanceClassesStaffMessages } from '../views/oa/addAttendanceClassesStaffLang'

import { messages as monthAttendanceManageMessages } from '../views/oa/monthAttendanceManageLang'
import { messages as staffAttendanceManageMessages } from '../views/oa/staffAttendanceManageLang'
import { messages as attendanceLogManageMessages } from '../views/oa/attendanceLogManageLang'
import { messages as workTypeMessages } from '../views/oa/workTypeLang'
import { messages as startWorkMessages } from '../views/oa/startWorkLang'
import { messages as addWorkMessages } from '../views/oa/addWorkLang'
import { messages as editWorkMessages } from '../views/oa/editWorkLang'
import { messages as workDetailMessages } from '../views/oa/workDetailLang'
import { messages as doWorkMessages } from '../views/oa/doWorkLang'
import { messages as copyWorkMessages } from '../views/oa/copyWorkLang'
import { messages as workPoolMessages } from '../views/oa/workPoolLang'
import { messages as workDeductionMessages } from '../views/oa/workDeductionLang'
import { messages as newOaWorkflowMessages } from '../views/oa/newOaWorkflowLang'
import { messages as newOaWorkflowDetailMessages } from '../views/oa/newOaWorkflowDetailLang'
import { messages as newOaWorkflowFormEditMessages } from '../views/oa/newOaWorkflowFormEditLang'
import { messages as simplifyNotepadManageMessages } from '../views/oa/simplifyNotepadManageLang'
import { messages as uodoComplaintsMessages } from '../views/oa/uodoComplaintsLang'
import { messages as complaintDetailMessages } from '../views/oa/complaintDetailLang'
import { messages as visitUndoMessages } from '../views/oa/visitUndoLang'
import { messages as doHistoryComplaintsMessages } from '../views/oa/doHistoryComplaintsLang'
import { messages as myAuditHistoryOrdersMessages } from '../views/resource/myAuditHistoryOrdersLang'
import { messages as visitFinishMessages } from '../views/oa/visitFinishLang'
import { messages as workTaskDetailMessages } from '../views/oa/workTaskDetailLang'


export const messages ={
    en:{
        ...activitiesTypeManageMessages.en,
        ...activitiesManageMessages.en,
        ...noticeManageMessages.en,
        ...addNoticeViewMessages.en,
        ...editNoticeViewMessages.en,
        ...noticeDetailMessages.en,
        ...complaintTypeMessages.en,
        ...addComplaintTypeMessages.en,
        ...editComplaintTypeMessages.en,
        ...addComplaintMessages.en,
        ...complaintMessages.en,
        ...notepadManageMessages.en,
        ...visitManageMessages.en,
        ...questionTitleMessages.en,
        ...questionAnswerManageMessages.en,
        ...printQuestionAnswerMessages.en,
        ...addQuestionAnswerMessages.en,
        ...editQuestionAnswerMessages.en,
        ...printQuestionAnswerDetailMessages.en,
        ...ownerVotingMessages.en,
        ...addOwnerVotingMessages.en,
        ...editOwnerVotingMessages.en,
        ...printOwnerVotingMessages.en,
        ...oaWorkflowManageMessages.en,
        ...newOaWorkflowManageMessages.en,
        ...newOaWorkflowDoingMessages.en,
        ...attendanceClassesManageMessages.en,
        ...attendanceClassesStaffManageMessages.en,
        ...todayAttendanceManageMessages.en,
        ...addAttendanceClassesStaffMessages.en,
        ...monthAttendanceManageMessages.en,
        ...staffAttendanceManageMessages.en,
        ...attendanceLogManageMessages.en,
        ...workTypeMessages.en,
        ...startWorkMessages.en,
        ...addWorkMessages.en,
        ...editWorkMessages.en,
        ...workDetailMessages.en,
        ...doWorkMessages.en,
        ...copyWorkMessages.en,
        ...workPoolMessages.en,
        ...workDeductionMessages.en,
        ...newOaWorkflowMessages.en,
        ...newOaWorkflowDetailMessages.en,
        ...newOaWorkflowFormEditMessages.en,
        ...simplifyNotepadManageMessages.en,
        ...uodoComplaintsMessages.en,
        ...complaintDetailMessages.en,
        ...visitUndoMessages.en,
        ...doHistoryComplaintsMessages.en,
        ...myAuditHistoryOrdersMessages.en,
        ...visitFinishMessages.en,
        ...workTaskDetailMessages.en,
    },
    zh:{    
        ...activitiesTypeManageMessages.zh, 
        ...activitiesManageMessages.zh,
        ...noticeManageMessages.zh,
        ...addNoticeViewMessages.zh,
        ...editNoticeViewMessages.zh,
        ...noticeDetailMessages.zh,
        ...complaintTypeMessages.zh,
        ...addComplaintTypeMessages.zh,
        ...editComplaintTypeMessages.zh,
        ...addComplaintMessages.zh,
        ...complaintMessages.zh,
        ...notepadManageMessages.zh,
        ...visitManageMessages.zh,
        ...questionTitleMessages.zh,
        ...questionAnswerManageMessages.zh,
        ...printQuestionAnswerMessages.zh,
        ...addQuestionAnswerMessages.zh,
        ...editQuestionAnswerMessages.zh,
        ...printQuestionAnswerDetailMessages.zh,
        ...ownerVotingMessages.zh,
        ...addOwnerVotingMessages.zh,
        ...editOwnerVotingMessages.zh,
        ...printOwnerVotingMessages.zh,
        ...oaWorkflowManageMessages.zh,
        ...newOaWorkflowManageMessages.zh,
        ...newOaWorkflowDoingMessages.zh,
        ...attendanceClassesManageMessages.zh,
        ...attendanceClassesStaffManageMessages.zh,
        ...todayAttendanceManageMessages.zh,
        ...addAttendanceClassesStaffMessages.zh,
        ...monthAttendanceManageMessages.zh,
        ...staffAttendanceManageMessages.zh,
        ...attendanceLogManageMessages.zh,
        ...workTypeMessages.zh,
        ...startWorkMessages.zh,
        ...addWorkMessages.zh,
        ...editWorkMessages.zh,
        ...workDetailMessages.zh,
        ...doWorkMessages.zh,
        ...copyWorkMessages.zh,
        ...workPoolMessages.zh,
        ...workDeductionMessages.zh,
        ...newOaWorkflowMessages.zh,
        ...newOaWorkflowDetailMessages.zh,
        ...newOaWorkflowFormEditMessages.zh,
        ...simplifyNotepadManageMessages.zh,
        ...uodoComplaintsMessages.zh,
        ...complaintDetailMessages.zh,
        ...visitUndoMessages.zh,
        ...doHistoryComplaintsMessages.zh,
        ...myAuditHistoryOrdersMessages.zh,
...visitFinishMessages.zh,
        ...workTaskDetailMessages.zh,
    },
    'zh-TW': {
        ...activitiesTypeManageMessages['zh-TW'],
        ...activitiesManageMessages['zh-TW'],
        ...noticeManageMessages['zh-TW'],
        ...addNoticeViewMessages['zh-TW'],
        ...editNoticeViewMessages['zh-TW'],
        ...noticeDetailMessages['zh-TW'],
        ...complaintTypeMessages['zh-TW'],
        ...addComplaintTypeMessages['zh-TW'],
        ...editComplaintTypeMessages['zh-TW'],
        ...addComplaintMessages['zh-TW'],
        ...complaintMessages['zh-TW'],
        ...notepadManageMessages['zh-TW'],
        ...visitManageMessages['zh-TW'],
        ...questionTitleMessages['zh-TW'],
        ...questionAnswerManageMessages['zh-TW'],
        ...printQuestionAnswerMessages['zh-TW'],
        ...addQuestionAnswerMessages['zh-TW'],
        ...editQuestionAnswerMessages['zh-TW'],
        ...printQuestionAnswerDetailMessages['zh-TW'],
        ...ownerVotingMessages['zh-TW'],
        ...addOwnerVotingMessages['zh-TW'],
        ...editOwnerVotingMessages['zh-TW'],
        ...printOwnerVotingMessages['zh-TW'],
        ...oaWorkflowManageMessages['zh-TW'],
        ...newOaWorkflowManageMessages['zh-TW'],
        ...newOaWorkflowDoingMessages['zh-TW'],
        ...attendanceClassesManageMessages['zh-TW'],
        ...attendanceClassesStaffManageMessages['zh-TW'],
        ...todayAttendanceManageMessages['zh-TW'],
        ...addAttendanceClassesStaffMessages['zh-TW'],
        ...monthAttendanceManageMessages['zh-TW'],
        ...staffAttendanceManageMessages['zh-TW'],
        ...attendanceLogManageMessages['zh-TW'],
        ...workTypeMessages['zh-TW'],
        ...startWorkMessages['zh-TW'],
        ...addWorkMessages['zh-TW'],
        ...editWorkMessages['zh-TW'],
        ...workDetailMessages['zh-TW'],
        ...doWorkMessages['zh-TW'],
        ...copyWorkMessages['zh-TW'],
        ...workPoolMessages['zh-TW'],
        ...workDeductionMessages['zh-TW'],
        ...newOaWorkflowMessages['zh-TW'],
        ...newOaWorkflowDetailMessages['zh-TW'],
        ...newOaWorkflowFormEditMessages['zh-TW'],
        ...simplifyNotepadManageMessages['zh-TW'],
        ...uodoComplaintsMessages['zh-TW'],
        ...complaintDetailMessages['zh-TW'],
        ...visitUndoMessages['zh-TW'],
        ...doHistoryComplaintsMessages['zh-TW'],
        ...myAuditHistoryOrdersMessages['zh-TW'],
        ...visitFinishMessages['zh-TW'],
        ...workTaskDetailMessages['zh-TW'],
    }
}